import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.2488 3.2496)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M7.75 1.5H1.75C1.6123 1.50026 1.50025 1.6123 1.5 1.75V15.75C1.5 15.8879 1.61215 15.9997 1.75 16H7.75V17.5H1.75C0.783721 17.4997 -5.95948e-08 16.7163 0 15.75V1.75C0.000247107 0.783871 0.783873 0.000257518 1.75 0H7.75V1.5ZM19.2803 8.21973C19.4208 8.36027 19.4999 8.55125 19.5 8.75C19.5 8.94891 19.4209 9.13962 19.2803 9.28027L13.2803 15.2803L12.2197 14.2197L16.9395 9.5H4.75V8H16.9395L12.2197 3.28027L13.2803 2.21973L19.2803 8.21973Z",
			fill: "currentColor"
		})
	})
});
export default SvgLogout;
